module.exports = __webpack_public_path__ + "Piksl_2_XL.svg?9d564e5c8237d2e3732e48bce9953d93";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/Piksl_2_XL.svg
// module id = 206
// module chunks = 0